export const NavigationTestIds = {
  navMenuToggle: 'nav-menu-toggle',
};
